import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { LOADS_SOURCING } from './actions';

export const reducers = createReducer(
	initialState,
	on(LOADS_SOURCING.CARRIER.CARRIER_ID_SUCCESS, (state, action: any) => ({
		...state,
		carrierId: action.carrierId,
	})),
	on(LOADS_SOURCING.ACCOUNT.ID_SUCCESS, (state, action: any) => ({
		...state,
		accountId: action.accountId,
	})),
	on(LOADS_SOURCING.ACCOUNT.LOGO_SUCCESS, (state, action: any) => ({
		...state,
		accountLogoUrl: action.accountLogoUrl,
	})),
	on(LOADS_SOURCING.ACCOUNT.BUSINESS_NAME, (state, action: any) => ({
		...state,
		businessName: action.businessName,
	})),
	on(LOADS_SOURCING.LOADS_LIST.PAGE, (state, action: any) => ({
		...state,
		currentPage: action.currentPage,
	})),
	on(LOADS_SOURCING.LOADS_LIST.PAGE_SIZE, (state, action: any) => ({
		...state,
		pageSize: action.pageSize,
	})),

	on(LOADS_SOURCING.CARRIER.SUCCESS, (state, action: any) => ({
		...state,
		carrier: action.data,
	})),

	on(LOADS_SOURCING.LOADS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(LOADS_SOURCING.LOADS_LIST.SUCCESS, (state, action: any) => ({
		...state,
		loading: false,
		loadsList: action.data,
		total: action.total_pages,
	})),
	on(LOADS_SOURCING.OFFER.DIALOG_LOAD_SUCCESS, (state, action: any) => ({
		...state,
		loadsList: state.loadsList.map((loadRaw) => {
			let load = Object.assign({}, loadRaw);
			if (action.id === load.id) {
				load.offerSent = true;
			}
			return load;
		}),
		successfulLoads: [...state.successfulLoads, action],
		offerSubmitted: true,
	})),
	on(LOADS_SOURCING.OFFER.DIALOG_LOAD_FAILURE, (state, action: any) => ({
		...state,
		unsuccessfulLoads: [...state.unsuccessfulLoads, action],
	})),
	on(LOADS_SOURCING.OFFER.DIALOG_RATE_CHANGE, (state, action: any) => ({
		...state,
		currentRateSelection: action.rate,
	})),
	on(LOADS_SOURCING.LOADS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),
	on(LOADS_SOURCING.OFFER.OPEN_DIALOG, (state, action: any) => ({
		...state,
		offerDialogOpen: true,
	})),
	on(LOADS_SOURCING.OFFER.CLOSE_DIALOG, (state, action: any) => ({
		...state,
		unsuccessfulLoads: [],
		successfulLoads: [],
		currentRateSelection: null,
		offerDialogOpen: false,
	}))
);
